import React, { Fragment } from 'react';
import { injectIntl } from 'react-intl';
import { withRouter } from 'react-router-dom';
import { Form } from '@ant-design/compatible';
import {
	Button,
	Col,
	Collapse,
	Input,
	InputNumber,
	message,
	Radio,
	Row,
	Select,
	Spin,
	Statistic,
	Table,
	Tooltip,
	Typography,
} from 'antd';
import moment from 'moment';
import PropTypes from 'prop-types';
import EllipsisTooltip from '../../../components/EllipsisTooltip';
import { commissionBracketsType } from '../../../constants/global';
import {
	getactionMessages,
	getCommissionMessages,
	getErrorMessages,
	getFields,
	getInvoicingMessages,
	getLanguageIntl,
	getModalMessages,
} from '../../../constants/messages';
import { applyObject, displayCurrency, existsInArray, getNestedValue } from '../../../utilities/util';
import { ReturnExchangeRate } from '../../ExchangeRate/actions';
import PopoverProductsTable from '../../Invoices/PopoverProductsTable';
import {
	AddCommission,
	LoadCommissionAnnualPercent,
	LoadCommissionBrackets,
	LoadCommissionForEdit,
	LoadCommissionProductsConfig,
	LoadCommissionSalesPercent,
	LoadInvoices,
	LoadNoCommissionInvoices,
	LoadSalesmen,
	UpdateCommission,
} from '../actions';
import { STATUS } from '../constants';
import '@ant-design/compatible/assets/index.css';
const { PAID } = STATUS;

const FormItem = Form.Item;
const { Option } = Select;
const RadioButton = Radio.Button;
const RadioGroup = Radio.Group;
const { Panel } = Collapse;

let commissionMessages = getCommissionMessages(),
	fieldMessages = getFields(),
	intlMessages = getLanguageIntl(),
	actionMessages = getactionMessages(),
	errorMessages = getErrorMessages(),
	invoicingMessages = getInvoicingMessages(),
	modalMessages = getModalMessages();

const messages = {
	...commissionMessages,
	...fieldMessages,
	...intlMessages,
	...actionMessages,
	...errorMessages,
	...invoicingMessages,
	...modalMessages,
};

class Generator extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			isLoading: false,
			commission: {},
			salesmen: [],
			invoices: [],
			expandInvoices: false,
			isSaving: false,
			commissionAnnualPercent: 0,
			commissionSalesPercent: 0,
			commissionProductsAnnual: [],
			commissionProductsSales: [],
			commissionProductsLeased: [],
			customPriceProductsSales: [],
			customPriceProductsLeased: [],
			commissionLeasedBrackets: [],
			commissionSalesBrackets: [],
			exchangeRate: 0,
			isEdit: false,
			noCommissionInvoices: [],
			noCommissionInvoicesCount: 0,
			noCommissionInvoicesCurrentPage: 1,
			initialPanel: props.match.params.id ? 4 : 2,
			selectedCommissionType: {},
			customUnit: '$',
			customAmount: 1,
			disabledRows: {},
		};
	}

	componentDidMount() {
		const { props, setLoading, getIntl } = this;
		const { form } = props;
		const { id } = props.match.params;
		const { resetFields, setFieldsValue } = form;
		let isEdit = false;
		const promises = [
			new Promise((resolve, reject) => {
				LoadCommissionAnnualPercent()
					.then((response) => resolve(response))
					.catch(() => reject(1));
			}),
			new Promise((resolve, reject) => {
				LoadCommissionSalesPercent()
					.then((response) => resolve(response))
					.catch(() => reject(1));
			}),
			new Promise((resolve, reject) => {
				LoadCommissionProductsConfig('COMMISSION_PRODUCTS_LEASED')
					.then((response) => resolve(response))
					.catch(() => reject(4));
			}),
			new Promise((resolve, reject) => {
				LoadCommissionProductsConfig('COMMISSION_PRODUCTS_SALED')
					.then((response) => resolve(response))
					.catch(() => reject(4));
			}),
			new Promise((resolve, reject) => {
				LoadCommissionProductsConfig('COMMISSION_PRODUCTS_ANNUAL')
					.then((response) => resolve(response))
					.catch(() => reject(4));
			}),
			new Promise((resolve, reject) => {
				LoadCommissionProductsConfig('COMMISSION_CUSTOM_PRICE_PRODUCTS_LEASED')
					.then((response) => resolve(response))
					.catch(() => reject(4));
			}),
			new Promise((resolve, reject) => {
				LoadCommissionProductsConfig('COMMISSION_CUSTOM_PRICE_PRODUCTS_SALED')
					.then((response) => resolve(response))
					.catch(() => reject(4));
			}),
			new Promise((resolve, reject) => {
				LoadCommissionBrackets(commissionBracketsType.LEASED)
					.then((response) => resolve(response))
					.catch(() => reject(1));
			}),
			new Promise((resolve, reject) => {
				LoadCommissionBrackets(commissionBracketsType.SALES)
					.then((response) => resolve(response))
					.catch(() => reject(1));
			}),
			new Promise((resolve, reject) => {
				ReturnExchangeRate()
					.then((response) => resolve(response))
					.catch(() => reject(2));
			}),
		];
		if (id) {
			isEdit = true;
			promises.push(
				new Promise((resolve, reject) => {
					LoadCommissionForEdit(id)
						.then((response) => resolve(response))
						.catch(() => reject(3));
				})
			);
		} else {
			promises.push(
				new Promise((resolve, reject) => {
					LoadSalesmen()
						.then((response) => resolve(response))
						.catch(() => reject(0));
				})
			);
		}
		setLoading(true);
		Promise.all(promises)
			.then((data) => {
				const commissionAnnualPercent = data[0].value;
				const commissionSalesPercent = data[1].value;
				const commissionProductsLeased = data[2].value;
				const commissionProductsSales = data[3].value;
				const commissionProductsAnnual = data[4].value;
				const customPriceProductsLeased = data[5].value;
				const customPriceProductsSales = data[6].value;
				const commissionLeasedBrackets = data[7];
				const commissionSalesBrackets = data[8];
				const exchangeRate = data[9];
				if (isEdit) {
					const commission = data[10] || {};
					const {
						invoiceEntries: entries,
						noCommissionInvoices,
						pendingInvoices: invoices,
						salesPersonId,
					} = commission;
					const invoiceEntries = entries.map(({ invoice, amount }) => ({
						...invoice,
						amount,
						key: invoice.id,
					}));
					this.setState({
						commissionAnnualPercent,
						commissionSalesPercent,
						commissionProductsLeased,
						commissionProductsSales,
						commissionProductsAnnual,
						commissionLeasedBrackets,
						commissionSalesBrackets,
						customPriceProductsLeased,
						customPriceProductsSales,
						exchangeRate,
						isEdit,
						commission,
						invoices,
						invoiceEntries,
						noCommissionInvoices,
						isLoading: false,
						expandInvoices: true,
					});
					resetFields();
					setFieldsValue({ salesPersonId });
				} else {
					const salesmen = data[10] || [];
					this.setState({
						commissionAnnualPercent,
						commissionSalesPercent,
						commissionProductsLeased,
						commissionProductsSales,
						commissionProductsAnnual,
						commissionLeasedBrackets,
						commissionSalesBrackets,
						customPriceProductsLeased,
						customPriceProductsSales,
						salesmen,
						exchangeRate,
						isEdit,
						isLoading: false,
					});
				}
			})
			.catch((errorNumber) => {
				setLoading(false);
				switch (errorNumber) {
					case 0:
						message.error(getIntl('loadSalesmenError'));
						break;
					case 1:
						message.error(getIntl('loadCommissionPercentError'));
						break;
					case 2:
						message.error(getIntl('loadExchangeRateError'));
						break;
					case 3:
						message.error(getIntl('loadCommissionError'));
						break;
					case 4:
						message.error(getIntl('loadCommissionableProductIdsError'));
						break;
					default:
						message.error(getIntl('common'));
						break;
				}
			});
	}

	getIntl = (str, values = {}) => this.props.intl.formatMessage({ ...messages[str] }, values);
	setLoading = (isLoading) => this.setState({ isLoading });
	setSaving = (isSaving) => this.setState({ isSaving });

	cancel = () => this.props.history.push('/commissions');

	setCommissionType = (invoiceId, type) => {
		this.setState((prev) => ({
			selectedCommissionType: {
				...prev.selectedCommissionType,
				[invoiceId]: type,
			},
		}));
	};

	handleDisableRow = (invoiceId, value) => {
		this.setState((prev) => ({
			disabledRows: {
				...prev.disabledRows,
				[invoiceId]: value,
			},
		}));
	};

	save = () => {
		const { state, props, setSaving, getIntl, getCommissionTotal } = this;
		const { isEdit } = state;
		const { form } = props;
		const { validateFields } = form;
		const { id: commissionId = 0 } = props.match.params;
		validateFields({ force: true }, (err, values) => {
			if (!err) {
				const total = getCommissionTotal(false);
				if (total === 0) return message.warning(getIntl('saveZeroTotalCommissionError'));
				const { salesPersonId, bonus, editComment } = values;
				const parsedValues = {
					salesPersonId,
					bonus,
					editComment,
					newInvoiceEntries: [],
					updatedInvoiceEntries: [],
					noCommissionInvoiceEntries: [],
					markPending: [],
					markedNoCommission: [],
				};
				const apply = (key, value) => {
					const fieldSubstring = key.substring(0, 3);
					if (existsInArray(fieldSubstring, ['upd', 'noc']) && value === false)
						parsedValues.markPending.push(parseInt(key.substr(3)));
					else if (existsInArray(fieldSubstring, ['new', 'upd']) && value === 0)
						parsedValues.markedNoCommission.push(parseInt(key.substr(3)));
					else {
						if (fieldSubstring === 'new' && value !== false)
							parsedValues.newInvoiceEntries.push({ amount: value, invoiceId: parseInt(key.substr(3)) });
						if (fieldSubstring === 'upd')
							parsedValues.updatedInvoiceEntries.push({
								amount: value,
								invoiceId: parseInt(key.substr(3)),
							});
						if (fieldSubstring === 'noc' && value !== 0)
							parsedValues.noCommissionInvoiceEntries.push({
								amount: value,
								invoiceId: parseInt(key.substr(3)),
							});
					}
				};
				applyObject(values, apply);
				const saveFunc = isEdit ? UpdateCommission : AddCommission;
				setSaving(true);
				saveFunc(parsedValues, commissionId)
					.then(() => {
						message.success(getIntl('saveCommissionSuccess'));
						this.props.history.push('/commissions');
					})
					.catch(() => {
						message.error(getIntl('saveCommissionError'));
						setSaving(false);
					});
			}
		});
	};

	renderButtons = () => {
		const { state, getIntl, cancel, save } = this;
		const { isLoading, isSaving, isEdit } = state;
		const margin = '0.5em';
		return (
			<div className="buttons-align-right">
				<Button
					style={{ marginTop: margin, marginRight: margin }}
					onClick={cancel}
					key="cancel"
					disabled={isLoading || isSaving}
				>
					{getIntl('cancel')}
				</Button>
				<Button
					style={{ marginTop: margin }}
					type="primary"
					onClick={save}
					key="save"
					loading={isSaving}
					disabled={isLoading}
				>
					{isEdit ? getIntl('save') : getIntl('generate')}
				</Button>
			</div>
		);
	};

	onSalespersonChange = (salesPersonId) => {
		const { props, setLoading, getIntl } = this;
		const { resetFields, setFieldsValue } = props.form;
		setLoading(true);
		const promises = [
			new Promise((resolve, reject) => {
				LoadInvoices(salesPersonId)
					.then((response) => resolve(response))
					.catch(() => reject());
			}),
			new Promise((resolve, reject) => {
				LoadNoCommissionInvoices(salesPersonId)
					.then((response) => resolve(response))
					.catch(() => reject());
			}),
		];
		Promise.all(promises)
			.then((data) => {
				const invoices = data[0];
				const noCommissionInvoices = data[1];
				if (invoices.length < 1) message.warning(getIntl('salespersonHasNoInvoices'));
				this.setState({
					invoices,
					noCommissionInvoices,
					expandInvoices: true,
					isLoading: false,
					noCommissionInvoicesCurrentPage: 1,
					noCommissionInvoicesCount: noCommissionInvoices.length,
				});
				resetFields();
				setFieldsValue({ salesPersonId });
			})
			.catch(() => {
				setLoading(false);
				message.error(getIntl('getSalespersonInvoicesError'));
			});
	};

	renderSalespersonPicker = () => {
		const { state, props, getIntl, onSalespersonChange } = this;
		const { isLoading, salesmen, commission = {}, isEdit } = state;
		const { getFieldDecorator } = props.form;
		const salesPersonName = getNestedValue('salesPerson.name', commission);
		const salesPersonId = getNestedValue('salesPerson.id', commission);
		const options = isEdit
			? [
					<Option key={salesPersonId} value={salesPersonId}>
						{salesPersonName}
					</Option>,
				]
			: salesmen.map((salesman) => (
					<Option key={salesman.id} value={salesman.id}>
						{salesman.name}
					</Option>
				));
		return (
			<FormItem label={getIntl('salesperson')}>
				{getFieldDecorator('salesPersonId', {
					initialValue: isEdit ? salesPersonId : null,
					rules: [
						{
							required: true,
							message: getIntl('salespersonRequiredError'),
						},
					],
					onChange: onSalespersonChange,
				})(
					<Select
						className="job-full-component"
						showSearch
						allowClear={false}
						placeholder={getIntl('salesperson')}
						optionFilterProp="children"
						filterOption={(input, option) =>
							!Array.isArray(option.props.children) &&
							option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
						}
						dropdownMatchSelectWidth={false}
						notFoundContent={isLoading ? <Spin size="small" /> : getIntl('notFound')}
						disabled={isEdit}
					>
						{options}
					</Select>
				)}
			</FormItem>
		);
	};

	formatDate = (unformatedDate) => {
		if (!unformatedDate) return undefined;
		const { getIntl } = this;
		const locale = getIntl('intl');
		return moment(unformatedDate).locale(locale).format('MMMM DD, YYYY');
	};

	calculateCommissionSales = (invoiceProducts, customPrices, exchangeRate, isLps) => {
		const {
			state: {
				commissionProductsSales,
				customPriceProductsSales,
				commissionSalesPercent,
				commissionSalesBrackets,
			},
		} = this;
		let productsDetails = [];
		const productsSales = invoiceProducts.filter((prod) => commissionProductsSales.includes(prod.productId));
		const customPriceProducts = invoiceProducts.filter((prod) => customPriceProductsSales.includes(prod.productId));

		const totalPercentSales = productsSales.reduce((acc, prod) => {
			const commission = prod.price * commissionSalesPercent * prod.quantity;
			productsDetails.push({ name: `${prod.description}: $${commission}` });
			return acc + commission;
		}, 0);

		const totalCommissionSalesServices = customPriceProducts.reduce((acc, prod) => {
			const custom = customPrices.find((c) => c.productId === prod.productId);
			let effectivePrice = custom ? custom.price : prod.price;
			if (isLps && custom) {
				effectivePrice = effectivePrice / exchangeRate;
			}
			const bracket = commissionSalesBrackets.find((b) => effectivePrice >= b.min && effectivePrice <= b.max);
			const commission = bracket ? effectivePrice * bracket.multiplier * prod.quantity : 0;
			productsDetails.push({ name: `${prod.description}: $${commission}` });
			return acc + commission;
		}, 0);

		return {
			total: totalPercentSales + totalCommissionSalesServices,
			products: productsDetails,
		};
	};

	calculateCommissionLeased = (invoiceProducts, customPrices, exchangeRate, isLps) => {
		const {
			state: { customPriceProductsLeased, commissionLeasedBrackets },
		} = this;
		let productsDetails = [];

		const customPriceProducts = invoiceProducts.filter((prod) =>
			customPriceProductsLeased.includes(prod.productId)
		);
		const totalCommissionLeasedServices = customPriceProducts.reduce((acc, prod) => {
			const custom = customPrices.find((c) => c.productId === prod.productId);
			let effectivePrice = custom ? custom.price : prod.price;
			if (isLps && custom) {
				effectivePrice = effectivePrice / exchangeRate;
			}
			const bracket = commissionLeasedBrackets.find((b) => effectivePrice >= b.min && effectivePrice <= b.max);
			const commission = bracket ? effectivePrice * bracket.multiplier * prod.quantity : 0;
			productsDetails.push({ name: `${prod.description}: $${commission}` });
			return acc + commission;
		}, 0);

		return {
			total: totalCommissionLeasedServices,
			products: productsDetails,
		};
	};

	calculateCommissionAnnual = (invoiceProducts) => {
		const {
			state: { commissionAnnualPercent, commissionProductsAnnual },
		} = this;
		let productsDetails = [];

		const productsAnnual = invoiceProducts.filter((prod) => commissionProductsAnnual.includes(prod.productId));
		const totalPercentAnnual = productsAnnual.reduce((acc, prod) => {
			const commission = prod.price * commissionAnnualPercent * prod.quantity;
			productsDetails.push({ name: `${prod.description}: $${commission}` });
			return acc + commission;
		}, 0);

		return {
			total: totalPercentAnnual,
			products: productsDetails,
		};
	};

	renderCustomPriceButtons = (invoiceId, invoiceProducts, customPrices = [], exchangeRate, isLps = false) => {
		let detailProducts = [];
		let value = 0;
		let total = 0;

		const commissionAnnualProduct = this.calculateCommissionAnnual(invoiceProducts);
		if (commissionAnnualProduct.total === 0) {
			const commissionSalesProduct = this.calculateCommissionSales(
				invoiceProducts,
				customPrices,
				exchangeRate,
				isLps
			);
			const commissionLeasedProduct = this.calculateCommissionLeased(
				invoiceProducts,
				customPrices,
				exchangeRate,
				isLps
			);
			total = parseFloat(commissionLeasedProduct.total + commissionSalesProduct.total).toFixed(2);
			value = parseFloat(
				((commissionLeasedProduct.total + commissionSalesProduct.total) * exchangeRate).toFixed(2)
			);
			detailProducts = [...commissionSalesProduct.products, ...commissionLeasedProduct.products];
		} else {
			total = parseFloat(commissionAnnualProduct.total).toFixed(2);
			value = parseFloat((commissionAnnualProduct.total * exchangeRate).toFixed(2));
			detailProducts = [...commissionAnnualProduct.products];
		}
		const valueData = [];
		valueData.push(value);

		const buttons = (
			<Tooltip
				key={total}
				overlayStyle={{ maxWidth: 400 }}
				title={
					detailProducts.length > 0 ? (
						<Fragment>
							{detailProducts.map((p, id) => (
								<div key={id}>{p.name}</div>
							))}
						</Fragment>
					) : null
				}
			>
				<RadioButton
					value={value}
					onClick={() => this.handleDisableRow(invoiceId, false)}
					onChange={() => {
						this.setState({ customAmount: 1, customUnit: '$' });
						this.setCommissionType(invoiceId, 'price');
					}}
				>
					{displayCurrency(total, false)}
				</RadioButton>
			</Tooltip>
		);
		return { valueData, buttons };
	};

	calculateSubtotal = (invoiceProducts = [], isLps = false, exchangeRate) => {
		return invoiceProducts.reduce((sum, { price, quantity }) => {
			if (isLps) return sum + price * quantity;
			return sum + price * exchangeRate * quantity;
		}, 0);
	};

	renderInvoiceActions = (
		invoice,
		fieldNomenclature,
		showEditOption = true,
		customInitialValue = false,
		defaultPending = false
	) => {
		const { state, props, getIntl, renderCustomPriceButtons, calculateSubtotal, customCommission } = this;
		const { isEdit, selectedCommissionType, customPriceProductsSales, customPriceProductsLeased } = state;
		const { getFieldDecorator } = props.form;
		const {
			id: invoiceId,
			isLps: invoiceIsLps,
			invoiceProducts = [],
			exchangeRate,
			amount: editAmount = 0,
		} = invoice;
		const customPrices = getNestedValue('client.customPrices', invoice);
		const clientIsLps = getNestedValue('client.isLps', invoice);
		const productQuantity = invoiceProducts.reduce((sum, { quantity, productId }) => {
			const exists =
				existsInArray(productId, customPriceProductsLeased) ||
				existsInArray(productId, customPriceProductsSales);
			return exists ? sum + quantity : sum;
		}, 0);
		const { valueData = [], buttons: pricesButtons } = renderCustomPriceButtons(
			invoiceId,
			invoiceProducts,
			customPrices,
			exchangeRate,
			clientIsLps
		);
		const subtotal = calculateSubtotal(invoiceProducts, invoiceIsLps, exchangeRate);
		const selectedType = selectedCommissionType[invoiceId];
		const editOption =
			isEdit && showEditOption && !existsInArray(editAmount, valueData) ? (
				<RadioButton
					value={editAmount}
					onClick={() => this.handleDisableRow(invoiceId, false)}
					onChange={() => {
						this.setState({ customAmount: 1, customUnit: '$' });
						this.setCommissionType(invoiceId, 'edit');
					}}
				>
					{displayCurrency(editAmount)}
				</RadioButton>
			) : null;
		return (
			<React.Fragment>
				<Row justify="center">
					<Col span={17}>
						<FormItem>
							{getFieldDecorator(`${fieldNomenclature}${invoiceId}`, {
								initialValue: defaultPending ? false : customInitialValue ? editAmount : false,
								preserve: fieldNomenclature === 'noc',
							})(
								<RadioGroup style={{ display: 'flex', justifyContent: 'center', marginTop: '10px' }}>
									{pricesButtons}
									<RadioButton
										value={0}
										onClick={() => this.handleDisableRow(invoiceId, false)}
										onChange={() => {
											this.setState({ customAmount: 1, customUnit: '$' });
											this.setCommissionType(invoiceId, 'noCommission');
										}}
									>
										{getIntl('noCommission')}
									</RadioButton>
									{editOption}
									<RadioButton
										value={false}
										onClick={() => this.handleDisableRow(invoiceId, false)}
										onChange={() => {
											this.setState({ customAmount: 1, customUnit: '$' });
											this.setCommissionType(invoiceId, 'pending');
										}}
									>
										<Tooltip title={getIntl('pendingTooltip')}>{getIntl('pending')}</Tooltip>
									</RadioButton>
									<RadioButton
										value={parseFloat(exchangeRate.toFixed(2)).toString()}
										style={{ textAlign: 'center' }}
										onChange={() => {
											this.setCommissionType(invoiceId, 'personalized');
										}}
										disabled={
											this.state.disabledRows && this.state.disabledRows[invoiceId] === true
										}
										onClick={() => this.handleDisableRow(invoiceId, true)}
									>
										{getIntl('personalized')}
									</RadioButton>
								</RadioGroup>
							)}
						</FormItem>
					</Col>
					<Col span={5}>
						{selectedType === 'personalized' &&
							customCommission(
								invoiceId,
								exchangeRate,
								fieldNomenclature,
								subtotal,
								productQuantity,
								invoiceProducts
							)}
					</Col>
				</Row>
			</React.Fragment>
		);
	};

	customCommission = (invoiceId, exchangeRate, fieldNomenclature, subtotal, productQuantity, invoiceProducts) => {
		const {
			props: {
				form: { getFieldDecorator },
			},
			calculateCustomCommission,
		} = this;

		return (
			<FormItem>
				{getFieldDecorator(`customValue${invoiceId}`)(
					<Input.Group compact style={{ display: 'flex', justifyContent: 'center', marginTop: '10px' }}>
						<Select
							defaultValue="$"
							options={[
								{ value: '$', label: '$' },
								{ value: '%', label: '%' },
								{ value: '$*C', label: '$*C' },
							]}
							onSelect={(value) => {
								this.setState({ customUnit: value }, () => {
									calculateCustomCommission(
										this.state.customAmount,
										this.state.customUnit,
										subtotal,
										exchangeRate,
										invoiceId,
										fieldNomenclature,
										productQuantity,
										invoiceProducts
									);
								});
							}}
						/>
						<InputNumber
							min={1}
							defaultValue={1}
							onChange={(value) => {
								this.setState({ customAmount: value }, () => {
									calculateCustomCommission(
										this.state.customAmount,
										this.state.customUnit,
										subtotal,
										exchangeRate,
										invoiceId,
										fieldNomenclature,
										productQuantity,
										invoiceProducts
									);
								});
							}}
						/>
					</Input.Group>
				)}
			</FormItem>
		);
	};

	calculateCustomCommission = (
		value,
		unit,
		subtotal,
		exchangeRate,
		invoiceId,
		fieldNomenclature,
		productQuantity,
		invoiceProducts
	) => {
		const {
			props: {
				form: { setFieldsValue },
			},
			state: { commissionProductsSales, commissionSalesPercent },
		} = this;
		if (unit === '$') {
			const result = parseFloat((value * exchangeRate).toFixed(2));
			setFieldsValue({ [`${fieldNomenclature}${invoiceId}`]: result });
		} else if (unit === '%') {
			const percent = value / 100;
			const result = parseFloat((subtotal * percent).toFixed(2));
			setFieldsValue({ [`${fieldNomenclature}${invoiceId}`]: result });
		} else if (unit === '$*C') {
			const productsSales = invoiceProducts.filter((prod) => commissionProductsSales.includes(prod.productId));
			const percentSales = productsSales.reduce((acc, prod) => {
				const commission = prod.price * commissionSalesPercent * prod.quantity;
				return acc + commission;
			}, 0);
			const totalSalesLps = parseFloat((percentSales * exchangeRate).toFixed(2));
			const customTotal = parseFloat((value * exchangeRate * productQuantity).toFixed(2));
			setFieldsValue({
				[`${fieldNomenclature}${invoiceId}`]: parseFloat((customTotal + totalSalesLps).toFixed(2)),
			});
		}
	};

	renderCommissionText = (invoiceId, fieldNomenclature) => {
		const commission = this.props.form.getFieldValue(`${fieldNomenclature}${invoiceId}`);
		return displayCurrency(commission || 0);
	};

	calculateInvoiceTotal = (invoice) => {
		const { calculateSubtotal } = this;
		const { isLps: invoiceIsLps, invoiceProducts, exchangeRate, taxExemption, isv } = invoice;
		const subtotal = calculateSubtotal(invoiceProducts, invoiceIsLps, exchangeRate);
		const total = taxExemption ? subtotal : subtotal + subtotal * isv;
		return displayCurrency(total.toFixed(2));
	};

	renderInvoiceList = (
		invoiceListSource = [],
		fieldNomenclature = 'new',
		pagination = false,
		showEditOption = false,
		customInitialValue = false,
		defaultPending = false
	) => {
		const {
			getIntl,
			formatDate,
			renderInvoiceActions,
			renderCommissionText,
			calculateInvoiceTotal,
			props: {
				form: { getFieldValue },
			},
		} = this;
		const selectedSalesPersonId = getFieldValue('salesPersonId');
		const dataSource = invoiceListSource.map((invoice) => ({ ...invoice, key: invoice.id }));
		const columns = [
			{
				title: getIntl('InvoiceNumber'),
				dataIndex: 'documentNumber',
				key: 'documentNumber',
				width: 300,
				render: (documentNumber, invoice) => {
					const { id: invoiceId, invoiceProducts = [] } = invoice;
					return (
						<PopoverProductsTable products={invoiceProducts}>
							<a
								href={`/invoices/${invoiceId}`}
								onClick={(e) => {
									e.preventDefault();
									this.props.history.push(`/invoices/${invoiceId}`);
								}}
							>
								{documentNumber}
							</a>
						</PopoverProductsTable>
					);
				},
			},
			{
				title: getIntl('Client'),
				dataIndex: 'clientName',
				key: 'clientName',
				width: 200,
				onCell: () => {
					return {
						style: {
							whiteSpace: 'nowrap',
							maxWidth: 200,
						},
					};
				},
				render: (clientName) => {
					return <EllipsisTooltip title={clientName}>{clientName}</EllipsisTooltip>;
				},
			},
			{
				title: getIntl('salesperson'),
				dataIndex: 'salesperson',
				key: 'salesperson',
				width: 200,
				render: (salesperson, invoice) => {
					const {
						client: { salesPersonId, salesPerson },
					} = invoice;
					return (
						<Typography.Text mark={salesPersonId !== selectedSalesPersonId}>
							{salesPerson.name}
						</Typography.Text>
					);
				},
			},
			{
				title: getIntl('date'),
				dataIndex: 'createdAt',
				key: 'createdAt',
				width: 200,
				render: (date) => formatDate(date),
			},
			{
				title: getIntl('total'),
				key: 'total',
				width: 150,
				render: (invoice) => calculateInvoiceTotal(invoice),
			},
			{
				title: getIntl('typeOfCommission'),
				key: 'type',
				width: 650,
				render: (invoice) =>
					renderInvoiceActions(
						invoice,
						fieldNomenclature,
						showEditOption,
						customInitialValue,
						defaultPending
					),
			},
			{
				title: getIntl('commission'),
				dataIndex: 'id',
				key: 'id',
				width: 200,
				render: (invoiceId) => renderCommissionText(invoiceId, fieldNomenclature),
			},
		];
		return <Table columns={columns} dataSource={dataSource} pagination={pagination} />;
	};

	renderPendingInvoiceList = () => {
		const { state, renderInvoiceList } = this;
		const { invoices, isEdit } = state;
		return renderInvoiceList(invoices, undefined, undefined, undefined, undefined, isEdit);
	};

	renderNoCommissionInvoiceList = () => {
		const { state, renderInvoiceList } = this;
		const { noCommissionInvoices, noCommissionInvoicesCount, noCommissionInvoicesCurrentPage } = state;
		const pagination = {
			defaultPageSize: 5,
			total: noCommissionInvoicesCount,
			current: noCommissionInvoicesCurrentPage,
			onChange: this.onNoCommissionChangePage,
		};
		return renderInvoiceList(noCommissionInvoices, 'noc', pagination, false, true);
	};

	onNoCommissionChangePage = (page) => {
		this.setState({
			noCommissionInvoicesCurrentPage: page,
		});
	};

	renderBonusField = () => {
		const { state, props, getIntl } = this;
		const { isEdit, commission } = state;
		const { getFieldDecorator } = props.form;
		const { bonusDescription, bonusAmount } = commission;
		const descriptionMaxLength = 255;
		return (
			<div className="commission-generator-bonus">
				<Row>
					<Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 18 }}>
						<FormItem label={getIntl('description')}>
							{getFieldDecorator(`bonus[description]`, {
								initialValue: isEdit ? bonusDescription : null,
								rules: [
									{
										whitespace: true,
										message: getIntl('bonusDescriptionWhitespaceError'),
									},
									{
										max: descriptionMaxLength,
										message: getIntl('bonusDescriptionLengthError', {
											maxLength: descriptionMaxLength,
										}),
									},
								],
							})(<Input className="job-partial-component" placeholder={getIntl('bonusDescription')} />)}
						</FormItem>
					</Col>
					<Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 6 }}>
						<FormItem label={getIntl('amount')}>
							{getFieldDecorator(`bonus[amount]`, {
								initialValue: isEdit ? bonusAmount : 0,
							})(
								<InputNumber
									className="job-full-component"
									min={0}
									precision={2}
									formatter={(value) => `L ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
									parser={(value) => value.replace(/L\s?|(,*)/g, '')}
								/>
							)}
						</FormItem>
					</Col>
				</Row>
			</div>
		);
	};

	getCommissionTotal = (includeBonus = true) => {
		const { props } = this;
		const { getFieldsValue, getFieldValue } = props.form;
		const values = getFieldsValue();
		let total = 0;
		const apply = (key, value) => {
			const fieldSubstring = key.substring(0, 3);
			if (existsInArray(fieldSubstring, ['new', 'upd', 'noc']) && typeof value === 'number') {
				total += value;
			}
		};
		applyObject(values, apply);
		const bonus = getFieldValue(`bonus[amount]`);
		if (bonus && typeof bonus === 'number' && includeBonus) total += bonus;
		return parseFloat(total.toFixed(2));
	};

	renderTotalStatistic = () => {
		const { getIntl, getCommissionTotal } = this;
		let total = getCommissionTotal();
		return (
			<Statistic
				className="commission-generator-total-statistic"
				title={getIntl('total')}
				value={displayCurrency(total || 0)}
			/>
		);
	};

	renderEditCommissionInvoiceEntries = () => {
		const { state, getIntl, renderInvoiceList } = this;
		const { isEdit, invoiceEntries } = state;
		if (!isEdit) return null;
		return (
			<Panel key={4} header={getIntl('invoicesForThisCommission')} forceRender>
				{renderInvoiceList(invoiceEntries, 'upd', false, true, true)}
			</Panel>
		);
	};

	renderEditPaidCommissionCommentField = () => {
		const { state, props, getIntl } = this;
		const { commission } = state;
		const { getFieldDecorator } = props.form;
		const { editComment = null } = commission;
		const maxLength = 255;
		return (
			<FormItem label={getIntl('editComment')}>
				{getFieldDecorator(`editComment`, {
					initialValue: editComment,
					rules: [
						{
							required: true,
							whitespace: true,
							message: getIntl('editCommentRequiredError'),
						},
						{
							max: maxLength,
							message: getIntl('editCommentLengthError', { maxLength }),
						},
					],
				})(<Input className="job-full-component" placeholder={getIntl('editComment')} />)}
			</FormItem>
		);
	};

	renderEditPaidCommissionReason = () => {
		const { state, getIntl, renderEditPaidCommissionCommentField } = this;
		const { isEdit, commission } = state;
		const { status, editComment } = commission;
		if ((isEdit && status === PAID) || editComment)
			return (
				<Panel key={5} header={getIntl('editCommissionReason')} forceRender>
					{renderEditPaidCommissionCommentField()}
				</Panel>
			);
		return null;
	};

	renderForm = () => {
		const {
			state,
			getIntl,
			renderSalespersonPicker,
			renderPendingInvoiceList,
			renderTotalStatistic,
			renderBonusField,
			renderNoCommissionInvoiceList,
			renderEditCommissionInvoiceEntries,
			renderEditPaidCommissionReason,
		} = this;
		const { expandInvoices, initialPanel } = state;
		return (
			<div>
				{renderSalespersonPicker()}
				<Collapse style={expandInvoices ? null : { display: 'none' }} defaultActiveKey={initialPanel}>
					<Panel key={1} header={getIntl('noCommissionInvoices')} forceRender>
						{renderNoCommissionInvoiceList()}
					</Panel>
					<Panel key={2} header={getIntl('pendingInvoices')} forceRender>
						{renderPendingInvoiceList()}
					</Panel>
					<Panel key={3} header={getIntl('bonus')} forceRender>
						{renderBonusField()}
					</Panel>
					{renderEditCommissionInvoiceEntries()}
					{renderEditPaidCommissionReason()}
				</Collapse>
				{renderTotalStatistic()}
			</div>
		);
	};

	fullRender = () => {
		const { state, renderForm, renderButtons } = this;
		const { isLoading, isSaving } = state;
		return (
			<Spin spinning={isLoading || isSaving}>
				<div className="view">
					{renderForm()}
					{renderButtons()}
				</div>
			</Spin>
		);
	};

	render() {
		return this.fullRender();
	}
}

Generator.propTypes = {
	intl: PropTypes.object.isRequired,
	form: PropTypes.object.isRequired,
	history: PropTypes.object.isRequired,
	match: PropTypes.shape({
		params: PropTypes.object.isRequired,
	}).isRequired,
	user: PropTypes.object.isRequired,
};

export default withRouter(injectIntl(Form.create()(Generator)));
